/**
 * Created by Jerker Nord on 2024-03-12.
 */
import {LonerMaxWinView} from "../../base/LonerMaxWinView";
import {Loner} from "../../../Loner";
import {LonerSound} from "../../../sound/LonerSound";
import {gsap} from "gsap";

export class LonerSSDMaxWinView extends LonerMaxWinView {

    constructor() {
        super();
        this.name = "LonerSSDMaxWinView";
    }

    public getMaxWinTL(buttonCallback: Function): gsap.core.Timeline {
        const maxWinTL: gsap.core.Timeline = gsap.timeline();
        maxWinTL.add(gsap.timeline({delay:0.4}));
        maxWinTL.add(()=>{
            Loner.ssdMainView.stopAllDucksMaxWin();
            if(Loner.soundPlayer.player.fetchSoundPlayer(LonerSound.SSD_MAX_SYM_PASSING_BY)?.isPlaying){
                Loner.soundPlayer.player.stopTrack(LonerSound.SSD_MAX_SYM_PASSING_BY);
            }
        });
        maxWinTL.add(super.getMaxWinTL(buttonCallback));

        return maxWinTL;
    }

    public endMaxWin(): void {
        Loner.ssdOutroView.hideOutro(Loner.isWinBelowStake());
        Loner.ssdMainView.reset();
        super.endMaxWin();
    }

    protected playMaxWinLoop(): void {
        Loner.soundPlayer.stopSound(LonerSound.SSD_MUSIC);
        Loner.soundPlayer.stopSound(LonerSound.SDD_LOOP);
        super.playMaxWinLoop();
    }
}